import 'core-js/stable';

require('./Check');
